import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const postApi = createApi({

  reducerPath: "postApi",

  // The base query to request data.
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL
    // baseUrl: 'https://apimat.blockcube.co/api'
  }),

  endpoints: (builder) => ({

    /* ~~~~~~~~~~~~~~~~~~~~~~~~LOGIN~~~~~~~~~~~~~~~~~~~~~~~~ */

    login: builder.mutation({
      query: (body) => {
        return {
          url: `/user-login`,
          responseHandler: (response) => response.json(),
          method: "POST",
          body: body,
          headers: {
            "Content-Type": "application/json",
          },
          // mode: "no-cors",
        };
      },
    }),

    /* ~~~~~~~~~~~~~~~~~~~~~~~~VERIFY OTP :LOGIN AUTH~~~~~~~~~~~~~~~~~~~~~~~~ */
    verifyOtpAuth: builder.mutation({
      query: (body) => {
        return {
          url: `/user-verify-login-otp`,
          responseHandler: (response) => response.json(),
          method: "POST",
          body: body,
          headers: {
            "Content-type": "application/json",
          },
        };
      },
    }),

    /* ~~~~~~~~~~~~~~~~~~~~~~~ SEND OTP~~~~~~~~~~~~~~~~~~~~~~~~ */

    sendOtp: builder.mutation({
      query: (data) => {
        return {
          url: `/sendOtp`,
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json",
          },
        };
      },
    }),

    /* ~~~~~~~~~~~~~~~~~~~~~~~~VERIFY OTP START RESET~~~~~~~~~~~~~~~~~~~~~~~~ */

    verifyOtp: builder.mutation({
      query: (body) => {
        return {
          url: `/verifyOtp`,
          responseHandler: (response) => response.json(),
          method: "POST",
          body: body,
          headers: {
            "Content-type": "application/json",
          },
        };
      },
    }),

    /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~RESET PASSWORD START~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

    rePass: builder.mutation({
      query: (body) => {
        return {
          url: `/forget-password`,
          responseHandler: (response) => response.json(),
          method: "POST",
          body: body,
          headers: {
            "Content-type": "application/json",
          },
        };
      },
    }),

    /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~DASHBOARD~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~  */

    dashboard: builder.mutation({
      query: () => {
        return {
          url: `/url_dashboard`,
          responseHandler: (response) => response.json(),
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: localStorage.getItem("tokenn")
          },
        };
      },
    }),

    /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~CREATE SMS START~@TEMPLATE~~~~~~~~~~~~~~~~~~~~~~~~~~ */

    createSms: builder.mutation({
      query: (body) => {
        return {
          url: `/create-sms-template`,
          responseHandler: (response) => response.json(),
          method: "POST",
          body: body,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: localStorage.getItem("token")
          },
        };
      },
    }),

    /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~URL CAMP CREATE~~~~~~~~~~~~~~~~~~~~~~~~~ */

    createUrlCamp: builder.mutation({
      query: (body) => {
        return {
          url: `/create_campaign`,
          responseHandler: (response) => response.json(),
          method: "POST",
          body: body,
          headers: {
            Authorization: localStorage.getItem("tokenn")
              // "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),

    /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~CREATE HEADER~~~~~~~~~~~~~~~~~~~~~~~~~ */

    registerHeader: builder.mutation({
      query: (body) => {
        return {
          url: `/header_registration`,
          responseHandler: (response) => response.json(),
          method: "POST",
          body: body,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: localStorage.getItem("tokenn")
          },
        };
      },
    }),

    /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~WINDOW HEAD~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~  */
    // windowHead: builder.mutation({
    //   query: () => {
    //     return {
    //       url: `/get-policies`,
    //       responseHandler: (response) => response.json(),
    //       method: "GET",
    //       headers: {
    //         "Content-type": "application/json; charset=UTF-8",
    //         Authorization: localStorage.getItem("token")
    //       },
    //     };
    //   },
    // }),

    /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~DATA KEYS / VARIABLES~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~  */

    variables: builder.mutation({
      query: () => {
        return {
          url: `/profilesDataKeys`,
          responseHandler: (response) => response.json(),
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: localStorage.getItem("token")
          },
        };
      },
    }),


  }),
});

export const {
  useLoginMutation,
  useSendOtpMutation,
  useVerifyOtpMutation,
  useRePassMutation,
  useDashboardMutation,
  useVerifyOtpAuthMutation,
  useWindowHeadMutation,
  useCreateSmsMutation,
  useCreateUrlCampMutation,
  useVariablesMutation,
  useRegisterHeaderMutation,
} = postApi;
